import request from '@/common/request'

class PISCOFINSService {
  getAll() {
    return request.get('/pis-cofins')
  }

  getById(id) {
    return request.get(`/pis-cofins/${id}`)
  }

  create(data) {
    return request.post('/pis-cofins', data)
  }

  update(id, data) {
    return request.patch(`/pis-cofins/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/pis-cofins/${id}`)
  }
}

export default new PISCOFINSService()
